// Confetti — a one-shot celebratory burst of colourful bits that fly out from the
// centre, tumble, and fade. Pure framer-motion (RAF) so it runs smoothly on
// mobile. Drop it into a position:relative (or fixed) container; it fills the
// container and is pointer-transparent, so it never blocks taps underneath.

import { motion } from 'framer-motion';

const COLORS = ['#ffba2b', '#2fe08a', '#37b6ff', '#ff5c8a', '#9b6bff', '#ffd35a'];

export function Confetti({ count = 20 }: { count?: number }) {
  return (
    <div aria-hidden style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
      {Array.from({ length: count }).map((_, i) => {
        const angle = (i / count) * Math.PI * 2 + (i % 2 ? 0.3 : -0.2);
        const dist = 55 + (i % 5) * 26;
        const dx = Math.cos(angle) * dist;
        const dy = Math.sin(angle) * dist - 30; // slight upward bias
        const color = COLORS[i % COLORS.length];
        const w = 6 + (i % 3) * 3;
        const rot = (i % 2 ? 1 : -1) * (140 + (i % 4) * 70);
        const dur = 1.0 + (i % 4) * 0.18;
        return (
          <motion.span
            key={i}
            initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
            animate={{ x: dx, y: [dy, dy + 130], opacity: [1, 1, 0], rotate: rot }}
            transition={{ duration: dur, ease: 'easeOut' }}
            style={{
              position: 'absolute',
              left: '50%',
              top: '40%',
              width: w,
              height: w * 1.7,
              marginLeft: -w / 2,
              borderRadius: 2,
              background: color,
            }}
          />
        );
      })}
    </div>
  );
}
